import { render, staticRenderFns } from "./StudentNews.vue?vue&type=template&id=93196144&scoped=true&"
import script from "./StudentNews.vue?vue&type=script&lang=js&"
export * from "./StudentNews.vue?vue&type=script&lang=js&"
import style0 from "./StudentNews.vue?vue&type=style&index=0&id=93196144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93196144",
  null
  
)

export default component.exports